/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { TaskObjectives } from './taskObjectives';

export type TaskAnalysis = TaskObjectives | null;
